import { z } from 'zod';
import { PersonDto } from './person';

export const PERSON_FEEDBACK_TEXT_MAX = 2000;

/** Сколько фидбэков читает ИИ: быстрый подбор людей/событий vs глубокий разбор.
 *  Это НЕ лимит хранения — история человека в БД не режется. */
export const PERSON_FEEDBACK_AI_QUICK = 3;
export const PERSON_FEEDBACK_AI_DEEP = 12;

/** Потолок одной страницы выдачи API: защита от неограниченного JSON, когда
 *  история выросла. Клиент может поднять до PERSON_FEEDBACK_PAGE_MAX. */
export const PERSON_FEEDBACK_PAGE_DEFAULT = 50;
export const PERSON_FEEDBACK_PAGE_MAX = 500;

/** Фидбэк всегда привязан к пересечению — событию или встрече (Event.kind=MEETING). */
export const PersonFeedbackDto = z.object({
  id: z.uuid(),
  personId: z.uuid(),
  eventId: z.uuid(),
  text: z.string().max(PERSON_FEEDBACK_TEXT_MAX),
  createdAt: z.iso.datetime(),
});
export type PersonFeedbackDto = z.infer<typeof PersonFeedbackDto>;

export const CreatePersonFeedbackInput = z.object({
  eventId: z.uuid(),
  text: z.string().trim().min(1).max(PERSON_FEEDBACK_TEXT_MAX),
});
export type CreatePersonFeedbackInput = z.infer<typeof CreatePersonFeedbackInput>;

/** Карточка целиком: сам человек + его лента (страница до PERSON_FEEDBACK_PAGE_DEFAULT записей). */
export const PersonDetailDto = PersonDto.extend({
  feedbacks: z.array(PersonFeedbackDto),
});
export type PersonDetailDto = z.infer<typeof PersonDetailDto>;
